module.exports = __webpack_public_path__ + "static/media/a12.36d0dbf1.jpg";